import { array, ord, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { Resource } from '@mews-commander/resources';
import { SearchType } from '@mews-commander/enums';
import { getResources } from '@mews-commander/legacy-entities/src/ducks/resources';
import { SearchFunction } from '../types';

const ordSearchResource = pipe(
    string.Ord,
    ord.contramap((resource: Resource) => resource.name)
);

export const searchResources: SearchFunction =
    (profileId, enterpriseId, term, { startIndex, count }) =>
    async (_, getState) => {
        const resources = getResources(getState(), { enterpriseId });
        const resultDisplayCount = (startIndex + 1) * count;
        const searchTerm = term.toLocaleLowerCase();

        const results = array.filter(
            ({ name, id }: Resource) => name.toLocaleLowerCase() === searchTerm || id === searchTerm
        )(Object.values(resources));

        const result = pipe(results, array.sort(ordSearchResource), array.takeLeft(resultDisplayCount));

        return Promise.resolve({
            searchType: SearchType.Resource,
            result,
            hasMore: results.length > resultDisplayCount,
        });
    };
